module.exports = __webpack_public_path__ + "characterAndLeadership-71633c15130d55ae41dc01fda815c177.svg";